var _path, _g, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSurfBg = function SvgSurfBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 325,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "surf_bg_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 0,
    width: 160,
    height: 303
  }, /*#__PURE__*/React.createElement("mask", {
    id: "surf_bg_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 0,
    width: 161,
    height: 303
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M15.624 0H175v302.944H15.624z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#surf_bg_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.013 302.226c1.084.379 2.578 0 3.537-.616 1.997-1.279 3.27-3.853 4.198-5.954 1.242-2.795 1.383-6.064 3.097-8.575 1.682-2.479 4.716-3.932 5.911-6.696 1.337-3.08-.047-6.807 1.242-9.902 1.65-3.964 6.792-5.101 9.512-8.417 4.072-5.022 1.399-13.234 5.282-18.414 1.65-2.211 4.292-3.538 5.849-5.828 2.5-3.679 1.933-9.396 5.628-11.86 1.934-1.295 4.45-1.2 6.634-1.974 10.14-3.569 6.588-20.309 14.48-27.653 3.506-3.253 8.82-4.137 11.995-7.706 3.616-4.075 3.302-10.187 3.192-15.651a107.342 107.342 0 0 1 1.918-22.536c1.839-9.522 5.77-19.756 14.48-23.925 8.049-3.854 18.975-1.927 24.84-8.67 3.112-3.585 3.836-8.781 6.87-12.429 6.587-7.944 20.438-5.117 27.686-12.46 4.512-4.58 5.203-11.955 9.621-16.63 4.041-4.248 10.266-5.353 15.942-6.775a91.771 91.771 0 0 0 26.868-11.528c7.703-4.88 15.045-11.465 17.451-20.294 1.289-4.721.676-10.043-1.667-14.34-2.091-3.837-6.178-5.369-8.961-8.511-3.333-3.775-4.952-6.807-9.747-9.207-3.459-1.058-7.169-.521-10.77-.41-16.24.504-32.7-8.245-48.878-4.36-7.53 1.817-15.297 7.391-21.853 11.513-6.949 4.359-13.174 9.634-19.935 14.213-6.005 4.075-13.536 5.307-20.375 7.391-6.587 2.006-12.844 4.88-18.819 8.323-8.065 4.643-16.995 9.617-23.755 16.14-5.99 5.796-9.92 13.123-10.203 21.54-.33 9.65 1.76 19.804-1.792 29.075-3.082 8.054-10.078 13.155-15.062 19.867-5.455 7.375-8.285 15.918-9.118 25.015-.833 9.096-1.792 16.945-6.006 24.873-3.317 6.222-8.977 11.576-9.59 18.604-.55 6.269 3.097 12.081 4.166 18.287 2.028 11.892-5.58 24.431-1.525 35.786 1.95 5.449 6.43 9.981 7.028 15.745.676 6.507-3.852 13.266-1.4 19.33 1.243 3.08 4.198 6.159 2.8 9.176-.598 1.295-2.375 3.206-2.139 4.722.157.963.676 1.5 1.368 1.737v-.016Z",
    fill: "#000"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#surf_bg_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#surf_bg_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-179.602-50.745c-2.972 32.676-5.679 65.475-8.783 98.09-2.835 31.094 11.4 43.06 58.95 64.349 109.417 48.823 218.706 100.713 328.071 151.732 18.913 8.795 35.051 6.756 36.032-4.551 6.975-80.421 13.958-160.92 21.198-241.217l-435.468-68.403Z",
    fill: "#FFB9F8"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#surf_bg_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-288.807 399.424c7.141 6.717 14.521 13.32 21.542 20.094 6.79 6.396 21.226 1.12 64.056-19.487 98.508-47.443 197.803-94.333 296.905-141.399 17.13-8.144 28.992-16.616 26.484-18.917-17.835-16.36-35.688-32.737-53.284-49.211l-355.703 208.92Z",
    fill: "#FFB9F8"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#surf_bg_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-196.13 592.612c-4.021 48.313-8.078 96.609-12.121 144.961 14.085-35.13 26.664-74.927 37.9-115.088 10.078-36.07 19.792-73.793 33.469-101.754 11.55-23.632 25.034-38.704 39.303-50.203 15.711-37.665 34.398-65.579 56.268-82.738 16.354-12.818 19.197 3.341 35.51 5.306-12.23 31.265 17.76 23.035 30.707-7.274 5.303-12.414.858-10.269 6.96-20.208 4.28-6.915 4.008-23.348 8.81-27.481C62.62 319.375 75.337 237.148 97.94 224.165c-22.986-31.547-54.384 41.252-80.072 33.575-30.023 71.107-52.02 83.776-90.907 118.884-3.205 2.882-6.435 5.608-9.68 8.279l-108.847 166.273a805.946 805.946 0 0 0-4.565 41.436Z",
    fill: "#71BBFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#surf_bg_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.552 33.364C54.472 71.223 23.37 109.046-7.753 146.923c32.019-21.178 65.442-47.09 97.94-74.071 29.176-24.238 58.992-50.058 86.558-65.512 23.291-13.066 43.307-17.92 61.938-19.358 34.844-22.36 66.612-34.925 94.9-36.742 21.147-1.348 14.286 13.697 26.925 24.61-28.237 19.022 1.787 29.243 30.083 11.423 11.589-7.298 6.609-8.044 17.454-12.832 7.574-3.312 16.764-17.12 23.184-17.824 29.269-3.103 87.125-64.195 113.64-62.125-1.318-39.289-86.93 21.094-104.208.102-66.087 42.007-74.516 22.268-127.452 29.32-4.356.571-8.644.999-12.913 1.373L113.152 1.53a810.005 810.005 0 0 0-27.6 31.833Z",
    fill: "#71BBFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#surf_bg_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.8 95.038c-1.257 2.172-2.72 2.615-4.64 4.922-4.075.56-1.729 4.889 1.449 5.969 4.476 1.521 4.858-1.432 7.53-3.092 4.685-2.91 7.411-5.362 13.12-7.355 4.194-1.465 15.126.11 19.784 1.186 6.939 1.601 10.587-7.714 13.893-11.3 4.764-5.167 6.611-10.915 13.817-14.099 7.14-3.155 15.522-3.487 23.393-4.724 8.707-1.37 15.164-2.501 21.092-8.932 5.032-5.457-.282-11.762-2.749-16.755-2.429-4.918-12.163-6.952-17.286-8.417-6.628-1.897-11.188-.684-17.561.53-7.094 1.35-11.751 8.656-18.585 9.957-5.429 1.034-16.099.117-19.347 4.957-6.41 9.55-8.877 19.054-21.76 23.552-4.913 1.715-6.97 10.642-8.214 15.007-.976 3.427-2.221 5.632-3.936 8.594Z",
    fill: "#71BBFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#surf_bg_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.332 48.119c28.608-7.147 74.571-23.772 95.196-48.01-12.034-20.05-31.944 24.957-43.978 4.908l-43.983 15.577c-11.565 12.949-17.706 10.08-7.235 27.525Z",
    fill: "#0A9F68"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#surf_bg_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-65.068 243.481c-1.145 2.35-.867 4.9-2.049 7.365-1.181 2.466-4.573 8.946-4.132 10.337.638 2.011-.253 5.784 3.138 6.505 3.277.697 7.87-1.344 11.296-2.515 12.575-4.299 24.684-11.04 36.828-16.445 6.14-2.734 12.7-4.036 19.015-6.525 3.078-1.213 4.459-2.975 7.94-3.612 3.344-.612 6.446-2.056 9.62-3.307 7.683-3.027 14.973-3.494 22.982-4.7 8.84-1.332 20.313-6.903 28.346-10.9 25.671-12.77 41.253-34.062 61.156-52.157 7.72-7.019 13.836-15.063 22.274-21.57 8.887-6.854 19.102-10.967 29.618-15.11 17.933-7.066 37.824-14.329 54.026-24.62 7.508-4.768 13.975-9.986 18.029-17.317 4.37-7.903-1.54-20.206-8.677-24.428-3.962-2.345-13.168-1.975-18.23-1.742-5.368.248-10.722 1.04-16.076 1.926-19.99 3.31-39.587 12.863-56.115 24.099-20.749 14.105-42.583 16.736-65.765 24.513-11.122 3.732-21.707 8.733-32.222 13.61-6.97 3.233-11.874 10.998-17.008 15.947-14.425 13.908-22.1 30.937-39.364 42.604-8.016 5.417-16.515 10.667-25.611 14.391-4.948 2.026-12.398 4.895-16.12 8.771-6.918 7.204-15.907 15.242-18.56 24.246-.966 3.283-2.811 7.495-4.34 10.634Z",
    fill: "#FFE665"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#surf_bg_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.944 187.538c-1.256 2.172-2.72 2.615-4.64 4.922-4.075.56-1.729 4.889 1.45 5.969 4.475 1.521 4.857-1.432 7.53-3.092 4.685-2.91 7.41-5.362 13.119-7.355 4.195-1.465 15.126.111 19.784 1.186 6.939 1.601 10.588-7.714 13.893-11.3 4.764-5.167 6.611-10.915 13.817-14.099 7.14-3.155 15.522-3.487 23.393-4.724 8.708-1.369 15.164-2.501 21.093-8.932 5.031-5.457-.283-11.762-2.75-16.755-2.429-4.918-12.163-6.952-17.286-8.417-6.627-1.897-11.188-.684-17.561.53-7.093 1.351-11.751 8.656-18.585 9.957-5.428 1.034-16.099.117-19.347 4.957-6.41 9.549-8.877 19.054-21.76 23.552-4.912 1.715-6.97 10.642-8.213 15.007-.977 3.427-2.222 5.632-3.937 8.594Z",
    fill: "#0A9F68"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.776 300.222C12.085 302.807 3.399 313.514.484 319.578a.9.9 0 0 0 .689 1.29c10.786 1.52 23.745-7.486 27.653-19.44a.93.93 0 0 0-1.05-1.206Z",
    fill: "url(#surf_bg_svg__k)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.646 280.841c.627-.019 1.264-.009 1.88-.127 1.452-.264 2.258-.693 3.7-1.006.687-.147 1.9-.626 2.507-.987 1.094-.655 1.68-2.717 2.625-2.668.349.156.339.645.22 1.007-.19.566-.339.938-.747 1.387.607-.039.886-.674.945-.537.1.107-.159.557-.258.654-.905.87-2.218 1.144-3.322 1.75-.935.508-1.721 1.26-2.686 1.7-.666.303-1.392.44-2.119.567-2.048.342-3.68 1.045-5.748 1.26-.11.01-.677-.469-.786-.488-.378-.098-.488-.567-.518-.948-.03-.362-.06-.743.13-1.055.318-.538 1.114-.215 1.631-.284.855-.117 1.7-.205 2.556-.234l-.01.009Z",
    fill: "#2E2C30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.317 279.899c-.523-.236-1.03-.504-1.537-.771-.82-.424-1.64-.857-2.458-1.28-1.606-.841-3.285-1.692-5.105-1.725-.1.003-.21.008-.271.075-.132.136.018.362.164.481.836.707 1.675 1.433 2.653 1.924.473.233.97.423 1.402.73.443.316 1.04.739 1.457 1.078 1.296 1.069 2.063.957 2.975 3.064.174.4 1.825-.007 2.255.054.224.029.447-.03.656-.117.616-.279 1.664-1.601 1.08-2.302-.24-.294-1.112-.365-1.48-.484-.608-.204-1.211-.44-1.8-.716l.009-.011Z",
    fill: "#2C2A26"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.627 296.267c.368.137.806.313.885.694.04.156 0 .323-.04.489-.586 2.609.1 4.016-.169 6.664-.03.332-.405 1.206-.196 1.469.14.176 1.07.358 1.425.143 1.05.215 1.426.214 2.71.215.2.01.438 0 .567-.147.17-.185.09-.488-.09-.655-.178-.166-.477-.128-1.049-.27-.935-.518-1.079-.169-1.089-1.224-.01-1.055.318-2.072.577-3.098.368-1.465.577-2.98.627-4.485.02-.518 0-1.065-.259-1.515-.239-.391-.636-.664-1.024-.908a206.236 206.236 0 0 0-5.77-3.567c-.536-.323-1.093-.645-1.71-.762-.617-.118-1.323.019-1.73.498-.409.479-.418 1.182-.2 1.769.915 2.365 4.297 3.879 6.525 4.69h.01Z",
    fill: "#3C3C41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.366 292.52c.308-.323 1.83-2.384 1.969-2.805.565-1.273.71-.766 1.634-1.987.339-.45 1.207-1.625 1.426-2.143.587-1.338.356-1.071.712-2.499-.08-.254.684-2.253.415-2.253-.646 0-1.502.039-1.72.019-.756-.068-1.98-.078-2.736-.137-.537-.039-.895.02-1.83-.361-.398-.166-.268.635-.716 1.075-.806.791-.915 2.003-1.124 3.107a12.882 12.882 0 0 1-1.7 4.359c-.319.517-.697 1.084-.577 1.69.119.626.736 1.016 1.332 1.261 1.194.479 1.89 1.749 2.915.674Z",
    fill: "#2C2A26"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7 290.625c-.407 1.573.27 3.234 1.214 4.563.945 1.329 2.178 2.453 3.103 3.802.17.244.329.508.378.801.05.332-.05.664-.119.987-.696 3.117 1.204 6.303.786 9.469-.05.401-.12.86.169 1.143.15.147.358.205.557.254 1.104.264 1.768.714 2.902.694.12 0 .239 0 .348-.059.309-.156.25-.644 0-.889-.248-.244-.712-.455-1.069-.812-.356-.357-.63-.536-.749-1.582-.14-1.28-.11-3.743-.04-5.032.07-1.29.24-2.58.13-3.86-.319-3.548-2.726-6.548-3.84-9.938-.179-.557-.338-1.154-.736-1.584-1.432-1.563-2.735.899-3.033 2.053v-.01Z",
    fill: "#2A2A2D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.254 276.837c.04-.234.089-.479.248-.654.11-.127.269-.206.428-.274.756-.332 1.7-.518 2.337.039.338.303.517.762.627 1.212.149.654.169 1.338.06 2.003-.03.205-.09.42-.24.547-.128.108-.317.137-.457.225-.368.244-.338.801-.328 1.261 0 .117 0 .234-.06.332-.06.107-.179.166-.298.205-.836.303-2.576.078-2.347-1.104.11-.547.358-.723.268-1.349-.11-.86-.358-1.553-.229-2.443h-.01Z",
    fill: "#3C3C41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.853 276.305c-.172-.086-.479-.256-.58-.41-.1-.144-.214-.231-.237-.406-.039-.29-.066-.572-.095-.864-.014-.107-.074-.257-.181-.233-.089.012-.103.132-.112.213-.008.247-.025.496-.03.753-.28-.357-.293-.839-.39-1.269-.097-.431-.374-.926-.831-.974a.278.278 0 0 0-.196.036c-.091.071-.104.201-.1.309 0 .828.16 1.655.443 2.435.08.216.178.43.32.598.19.212.446.335.71.438.477.183 1.537.535 2.023.194.487-.341-.463-.671-.744-.82ZM14.483 277.018c.15-.121.348-.356 1.078-.55.232 0 .402.049.588.166.11.068.146.23.174.34.046.182.133.344.098.537-.027.148-.076.321-.076.471 0 .218-.157.433-.196.646a5.435 5.435 0 0 1-.373 1.122c-.05.111-.058.355-.058.473 0 .246-.073.464-.118.701-.071.375-.386.571-.745.571-.788 0-1.764-.242-1.764-1.178 0-.318-.039-.625-.039-.943 0-.202.012-.589.218-.707.202-.115.344-.278.544-.392.27-.155.226-.415.355-.649.115-.206.108-.444.314-.608Z",
    fill: "#2C2A26"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M17.045 276.526c.03.313.149.616.139.928-.01.401-.219.763-.378 1.134a3.94 3.94 0 0 0-.308 1.72c.01.264.05.537-.02.791-.07.255-.249.509-.518.548-.338.049-.636-.264-.716-.596-.08-.333 0-.675.01-1.007.03-.625-.149-1.241-.218-1.866-.07-.626-.04-1.31.348-1.798.258-.323.815-.714 1.263-.694.776.019.358.234.408.84h-.01Z",
    fill: "#2C2A26"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "surf_bg_svg__c",
    x: -204.73,
    y: -66.745,
    width: 476.595,
    height: 351.636,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_17853_3253"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "surf_bg_svg__d",
    x: -304.807,
    y: 174.504,
    width: 441.321,
    height: 263.572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_17853_3253"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "surf_bg_svg__e",
    x: -224.251,
    y: 200.194,
    width: 338.192,
    height: 553.379,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_17853_3253"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "surf_bg_svg__f",
    x: -23.753,
    y: -135.124,
    width: 584.622,
    height: 298.047,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_17853_3253"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "surf_bg_svg__g",
    x: 119.99,
    y: 15.455,
    width: 150.34,
    height: 106.896,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_17853_3253"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "surf_bg_svg__h",
    x: 83.96,
    y: -21.166,
    width: 132.568,
    height: 85.284,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_17853_3253"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "surf_bg_svg__i",
    x: -87.288,
    y: 46.567,
    width: 357.803,
    height: 237.263,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_17853_3253"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "surf_bg_svg__j",
    x: 34.134,
    y: 107.955,
    width: 150.34,
    height: 106.896,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_17853_3253"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "surf_bg_svg__k",
    x1: 59.637,
    y1: 276.619,
    x2: -6.815,
    y2: 322.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })))));
};
export default SvgSurfBg;